import React from 'react';
import {ProductPlaceholder as ProductPlaceholderIcon} from '../../../../icons/dist';
import s from './ProductPlaceholder.scss';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {withGlobals} from '../../../../globalPropsContext';
import {ISliderGlobalProps} from '../../../sliderGlobalStrategy';

export enum ProductPlaceholderDataHooks {
  Root = 'product-placeholder',
  Image = 'product-placeholder-image',
  Text = 'product-placeholder-text',
}

class ProductPlaceholderComp extends React.Component<ISliderGlobalProps & IProvidedTranslationProps> {
  public render() {
    return (
      <div className={s.root} data-hook={ProductPlaceholderDataHooks.Root}>
        <div>
          <ProductPlaceholderIcon size="70px" data-hook={ProductPlaceholderDataHooks.Image} />
        </div>
        <p className={s.text} data-hook={ProductPlaceholderDataHooks.Text}>
          {this.props.t('sliderGalleryNoProductsMessageText')}
        </p>
      </div>
    );
  }
}

export const ProductPlaceholder = withGlobals(withTranslations()(ProductPlaceholderComp));
